import { render } from "./ShareCode.vue?vue&type=template&id=70cf486e&scoped=true"
import script from "./ShareCode.vue?vue&type=script&lang=js"
export * from "./ShareCode.vue?vue&type=script&lang=js"

import "./ShareCode.vue?vue&type=style&index=0&id=70cf486e&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cf486e"]])

export default __exports__